import { noop } from "@gr-common/async/function";
/**
 *
 */
const win = import.meta.env.SSR ? globalThis : window;
export const autoNamespace = /*           */ new Proxy(noop, {
    get: () => autoNamespace,
});
if (import.meta.env.SSR) {
    /**
 *
 */
    win.o_global ||= autoNamespace;
    win.o_util ||= autoNamespace;
}
else {
    /**
 *
 *
 *
 */
    /*                                                                 */
    win.o_global ||= {};
    win.o_util ||= {};
}
/*                   */
export { win };
export const { o_global, o_util } = win;
